<aside class="main-sidebar">
  <button class="sidebar-toggle" type="button" (click)="toggleSidebar()">
    <i class="collapse-icon"><img src="../../../../assets/images/menu-close.svg" alt=""></i>
    <i class="expand"><img src="../../../../assets/images/menu-close.svg" alt=""></i>
  </button>
  <section class="sidebar-custom-menu">
    <ul class="sidebar-menu tooltip-example">

      @if (menus[0].isdisplay) {
        <li appTooltip="Org Structure" placement="right" delay="100" [ngClass]="{'active': (authService.currentRoute == 'dashboard' || authService.currentRoute == 'entity')}">
          <a id="menu-entity" [routerLink]="['/entity']"><i class="icon-sidebar icon-users"></i><span>Org Structure</span></a>
        </li>
      }
      @if (menus[0].isdisplay) {
        <li appTooltip="Machines" placement="right" delay="100" [ngClass]="{'active': (authService.currentRoute == 'machine')}">
          <a id="menu-machine" [routerLink]="['/machine']"><i class="icon-sidebar icon-machine"></i><span>Machines</span></a>
        </li>
      }
      @if (menus[3].isdisplay) {
        <li [ngClass]="{'active': (authService.currentRoute == 'sales')}" appTooltip="Sales" placement="right" delay="100">
          <a id="menu-sales" href="#" [routerLink]="['/sales']"><i class="icon-sidebar icon-sales"></i><span>Sales</span></a>
        </li>
      }
      @if (roleService.objRole.isSystemAdmin || roleService.objRole.isGlobalMarketAdmin || roleService.objRole.isMarketAdmin || roleService.objRole.isCustomerAdmin || roleService.objRole.isLevel2Admin || roleService.objRole.isLevel3Admin) {
        <li appTooltip="Users" placement="right" delay="100" [ngClass]="{'active': (authService.currentRoute == 'user')}">
          <a id="menu-user" [routerLink]="['/user']"><i class="icon-sidebar icon-facility"></i><span>Users</span></a>
        </li>
      }
      @if ((roleService.objRole.isSystemAdmin || roleService.objRole.isGlobalMarketAdmin) && !drinkSetupFT) {
        <li appTooltip="Price Card Templates" placement="right" delay="100" [ngClass]="{'active': (authService.currentRoute == 'price-card-template')}">
          <a id="menu-price-card-template" [routerLink]="['/price-card-template']"><i class="icon-sidebar icon-drins-g-price"></i><span>Price Card Templates</span></a>
        </li>
      }
      @if ((roleService.objRole.isSystemAdmin || roleService.objRole.isGlobalMarketAdmin) && drinkSetupFT) {
        <li appTooltip="Drinks Setup" placement="right" delay="100" [ngClass]="{'active': (authService.currentRoute == 'drinks-setup')}">
          <a id="menu-drinks-setup" [routerLink]="['/drinks-setup']"><i class="icon-sidebar icon-drins-g-price"></i><span>Drinks Setup</span></a>
        </li>
      }
      @if (menus[2].isdisplay) {
        <li appTooltip="Price Card" placement="right" delay="100" [ngClass]="{'active': (authService.currentRoute == 'price-card')}">
          <a id="menu-price-card" [routerLink]="['/price-card']"><i class="icon-sidebar icon-price-card"></i><span>Price Card</span></a>
        </li>
      }
      @if (menus[6].isdisplay) {
        <li appTooltip="Alarm Template" placement="right" delay="100" [ngClass]="{'active': (authService.currentRoute == 'alarm-template')}">
          <a id="menu-alarm-template" [routerLink]="['/alarm-template']"><i class="icon-sidebar icon-event-alarms"></i><span>Alarm Template</span></a>
        </li>
      }
      @if ((menus[7].isdisplay)) {
        <li appTooltip="Alarms" placement="right" delay="100" [ngClass]="{'active': (authService.currentRoute == 'alarms')}">
          <a id="menu-alarms" [routerLink]="['/alarms']"><i class="icon-sidebar icon-alarms"></i><span>Alarms</span></a>
        </li>
      }
      @if (menus[10].isdisplay || roleService.objRole.isSystemAdmin) {
        <li appTooltip="Configuration" placement="right" delay="100" [ngClass]="{'active': (authService.currentRoute == 'configuration')}">
          <a id="menu-configuration" [routerLink]="['/configuration']"><i class="icon-sidebar icon-configuration"></i><span>Configuration</span></a>
        </li>
      }
      @if (menus[9].isdisplay) {
        <li appTooltip="User Audit" placement="right" delay="100" [ngClass]="{'active': (authService.currentRoute == 'user-audit')}">
          <a id="menu-user-audit" [routerLink]="['/user-audit']"><i class="icon-sidebar icon-user-audit"></i><span>User Audit</span></a>
        </li>
      }
      @if (menus[5].isdisplay) {
        <li appTooltip="User Verification Review" placement="right" delay="100" [ngClass]="{'active': (authService.currentRoute == 'user-verification-review')}">
          <a id="menu-user-verification-review" [routerLink]="['/user-verification-review']"><i class="icon-sidebar icon-users-verification"></i><span>User Verification Review</span></a>
        </li>
      }
      @if (menus[4].isdisplay) {
        <li appTooltip="Notifications" placement="right" delay="100" [ngClass]="{'active': (authService.currentRoute == 'notifications')}">
          @if (roleService.objRole.isUserAuditorGRIDR) {
            <a id="menu-notification" [routerLink]="['/notifications']"><i class="icon-sidebar icon-notification"></i><span>Notifications</span></a>
          }
          @if (!roleService.objRole.isUserAuditorGRIDR) {
            <a id="menu-notification"  [routerLink]="['/notifications']"><i class="icon-sidebar icon-notification"></i><span>Notifications ({{notificationCount}})</span></a>
          }
        </li>
      }
      @if (menus[8].isdisplay) {
        <li appTooltip="Audit Logs" placement="right" delay="100" [ngClass]="{'active': (authService.currentRoute == 'audit-logs')}">
          <a id="menu-audit-logs" [routerLink]="['/audit-logs']"><i class="icon-sidebar icon-auditlogs"></i><span>Audit Logs</span></a>
        </li>
      }
      @if ((roleService.objRole.isSystemAdmin || roleService.objRole.isMarketAdmin || roleService.objRole.isLevel2Admin || roleService.objRole.isLevel3Admin || roleService.objRole.isReleaseManager) && remoteUpdateFT) {
        <li appTooltip="Remote Update Management" placement="right" delay="100" [ngClass]="{'active': (authService.currentRoute == 'task-management-overview')}">
          <a id="menu-remote-update-tasks" [routerLink]="['/task-management-overview']"><i class="icon-remotetasks"></i><span>Remote Management</span></a>
        </li>
      }
    </ul>

  </section>
</aside>
<ng-template #infoAlertTemplate>
  <app-alert-confirm-dialog [alertConfirmDataModel]="alertConfirmDataModel" (onConfirm)="onConfirmOk()">
  </app-alert-confirm-dialog>
</ng-template>
